import React from "react";
import { siteConfig } from "../../config/siteConfig";
import Icon from "../ui/Icon";
import Reveal from "../ui/Reveal";

const DEFAULTS = {
  eyebrow: "Så fungerar det",
  title: "Kom igång i tre steg",
  subtitle: "",
  steps: [
    {
      icon: "📝",
      iconKey: "clipboard",
      title: "Registrera dig gratis",
      description: "Skapa konto på några sekunder — inget kort behövs.",
    },
    {
      icon: "🎯",
      iconKey: "target",
      title: "Träna och simulera",
      description:
        "Träna delområde för delområde och gör provsimuleringar i skarpt format.",
    },
    {
      icon: "🏆",
      iconKey: "trophy",
      title: "Gå till testet väl förberedd",
      description: "Följ din utveckling och gå till testet med självförtroende.",
    },
  ],
};

const HowItWorks = () => {
  const data = siteConfig.howItWorks || DEFAULTS;
  const steps = data.steps && data.steps.length ? data.steps : DEFAULTS.steps;

  return (
    <section id="como-funciona" className="py-20 md:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <Reveal>
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-slate-400">
              <span className="h-px w-6 bg-indigo-700/40" aria-hidden="true" />
              {data.eyebrow || DEFAULTS.eyebrow}
            </span>
          </Reveal>
          <Reveal index={1}>
            <h2 className="text-4xl md:text-5xl font-bold tracking-tight mt-4 mb-6 text-slate-900">
              {data.title || DEFAULTS.title}
            </h2>
          </Reveal>
          {data.subtitle ? (
            <Reveal index={2}>
              <p className="text-lg md:text-xl text-slate-600 leading-snug">
                {data.subtitle}
              </p>
            </Reveal>
          ) : null}
        </div>

        <div className="relative grid md:grid-cols-3 gap-10 md:gap-8">
          {/* Filet de liaison hairline (solo desktop) */}
          <div
            className="hidden md:block absolute top-12 left-[16.6%] right-[16.6%] h-px bg-slate-200/70"
            aria-hidden="true"
          />
          {steps.map((step, i) => (
            <Reveal key={i} index={i} className="relative text-center">
              <div className="relative z-10 w-24 h-24 mx-auto mb-6 rounded-2xl bg-white border border-slate-200 elev-1 flex items-center justify-center text-indigo-700">
                {step.iconKey ? (
                  <Icon name={step.iconKey} className="w-10 h-10" />
                ) : step.icon ? (
                  <span aria-hidden="true" className="text-4xl">
                    {step.icon}
                  </span>
                ) : null}
                <span className="absolute -top-3 -right-3 w-9 h-9 rounded-full bg-gradient-to-br from-indigo-700 to-sky-600 text-white font-display font-semibold tabular-nums text-sm flex items-center justify-center elev-2">
                  {i + 1}
                </span>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2">
                {step.title}
              </h3>
              <p className="text-slate-600 leading-relaxed max-w-xs mx-auto">
                {step.description}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
